import React, { Component } from 'react';
import { Modal, Table, Button, message, Spin, Popconfirm } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import UpdateChargeHospitalRecordRow from './UpdateChargeHospitalRecordRow';

/**
 * 修改负责医院科室固化弹框 展示该人员该月 user_responsible_hospital_record 固化列表 支持添加 修改 删除
 */
class UpdateChargeHospitalRecord extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
        recordList: [],
    }

    show = (parentRecord) => {
        const { userId, userCompellation, employeeCode, recordYearMonth } = parentRecord;
        const params = {
            userId,
            userCompellation,
            employeeCode,
            recordYearMonth,
        };
        this.setState({
            params,
            visible: true,
            recordList: [],
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    loadData = () => {
        const { params: { userId, recordYearMonth } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryUserChargeHospitalRecord,
            data: {
                userId,
                recordYearMonth,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    recordList: res.list || [],
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    //固化数据变动后 刷新列表 同时刷新外层人员信息总览表格
    loadDataAndOverview = () => {
        const { params: { userId } } = this.state;
        this.loadData();
        this.props.loadData(userId);
    }

    delRecord = (userResponsibleHospitalRecordId) => {
        const options = {
            method: 'POST',
            url: API_URL.user.delUserChargeHospitalRecord,
            data: {
                userResponsibleHospitalRecordId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadDataAndOverview();
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        //手动维护的数据 文字显示为蓝色
        const renderText = (text, record) => {
            const { manualFlag } = record;
            return manualFlag == 1 ? <span style={{ color: '#108ee9' }}>{text}</span> : text;
        };
        return [{
            title: '是否主要负责医院科室',
            dataIndex: 'yesNo',
            key: 'yesNo',
            width: 150,
            render: (text, record) => renderText(text == 1 ? '是' : text == 0 ? '否' : '', record)
        }, {
            title: '负责医院',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            width: 160,
            render: renderText,
        }, {
            title: '负责院区',
            dataIndex: 'courtyardArea',
            key: 'courtyardArea',
            width: 120,
            render: (text, record) => renderText(text ? text : '', record)
        }, {
            title: '负责科室',
            dataIndex: 'hospitalDepartmentName',
            key: 'hospitalDepartmentName',
            width: 140,
            render: renderText,
        }, {
            title: '操作',
            key: 'operation',
            width: 100,
            render: (text, record) => {
                return (
                    <span>
                        <a onClick={() => this.updateRecordRef.show(this.state.params, record)}>修改</a>
                        <Popconfirm title="确定删除该负责医院科室固化信息吗？" onConfirm={() => this.delRecord(record.userResponsibleHospitalRecordId)}>
                            <a style={{ marginLeft: 10 }}>删除</a>
                        </Popconfirm>
                    </span>
                );
            }
        }];
    }

    render() {
        const { visible, loading, recordList, params } = this.state;
        const monthStr = params.recordYearMonth ? `${String(params.recordYearMonth).slice(0, 4)}-${String(params.recordYearMonth).slice(4)}` : '';
        return (
            <Modal
                title={`修改负责医院科室固化（${params.userCompellation || ''}[${params.employeeCode || ''}] ${monthStr}）`}
                visible={visible}
                onCancel={this.hide}
                footer={null}
                className="setjde-modal addchildcontract"
                wrapClassName="vertical-center-modal"
                width="720px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px 10px' }}>
                        <Button type="primary" style={{ marginBottom: 10 }} onClick={() => this.updateRecordRef.show(params, null)}>添加</Button>
                        <Table
                            rowKey="userResponsibleHospitalRecordId"
                            loading={loading}
                            columns={this.getColumns()}
                            dataSource={recordList}
                            pagination={false}
                        />
                    </div>
                </Spin>
                <UpdateChargeHospitalRecordRow ref={el => this.updateRecordRef = el} loadData={this.loadDataAndOverview} />
            </Modal>
        )
    }
}

export default UpdateChargeHospitalRecord;



// WEBPACK FOOTER //
// ./src/components/user/userInfo/UpdateChargeHospitalRecord.js